import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { NavbarOptions } from "@obg/mat.ui.core";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { AccordionOptions, AccordionToggleChangeArgs } from "@obg/ngx.ui.global";
import { Subscription } from "rxjs";

import { VerificationConfigService } from "./verification.config";

@Component({
	selector: "obg-m-verification-page",
	templateUrl: "./verification.page.html",
	styleUrls: ["./verification.page.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class VerificationPage implements OnDestroy {
	@HostBinding("class.obg-m-verification") hostCssClass = true;

	expandedAccordion: string | undefined;
	readonly kyc = CORE_ROUTE.verification.root;
	readonly phoneVerification = CORE_ROUTE.verification.phoneVerification;
	readonly isPhoneVerificationEnabled = this.config.isPhoneVerificationEnabled();
	readonly accordionOptions: AccordionOptions = {
		collapseOthers: true,
	};

	navbarOptions: NavbarOptions = {
		preventDefaultBack: true,
		showCloseButton: true,
		hideBackButton: true,
	};

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CoreState>,
		private config: VerificationConfigService
	) {}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	getExpanded(key: string): boolean {
		return key === this.expandedAccordion;
	}

	onAccordionHeaderClick(key: string) {
		this.store.dispatch(RouteAction.navigate(key, undefined, { replaceUrl: true }));
	}

	onNavbarCloseClick() {
		return this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
	}

	accordionStateChanged(accordion: AccordionToggleChangeArgs) {
		this.expandedAccordion = accordion.isExpanded ? accordion.key : undefined;
	}
}
